// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2cl9w","signatureBlock":"Footer_signatureBlock__15uGx","signature":"Footer_signature__110IX"};